export default class {
    constructor() {
        this.produtos = [];
        this.loadProdutos();
    }

    loadProdutos() {
        this.produtos = [
            {
                id: 1,
                title: 'Vela',
                images: [
                    {
                        url: 'assets/images/produto-1.jpg'
                    }
                ],
                url: 'produto-1'
            },
            {
                id: 3,
                title: 'Vela',
                images: [
                    {
                        url: 'assets/images/produto-2.jpg'
                    }
                ],
                url: 'produto-2'
            },
            {
                id: 2,
                title: 'Vela',
                images: [
                    {
                        url: 'assets/images/produto-3.jpg'
                    }
                ],
                url: 'produto-3'
            }
        ]
    }

    take(number) {
        return this.produtos.slice().slice(0, number);
    }
}